import makeStyles from "utils/makeStyles";

export default makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
  },
  graphContainer: {
    height: 400,
    position: "relative",
    marginTop: "20px",
    padding: 0,
  },
  selectHeader: {
    padding: "0 1rem",
    alignItems: "center",
    // Keep every filter control the same compact height (40px)
    "& .inputDatePicker": {
      height: 40,
    },
    "& .inputDatePicker input": {
      height: 40,
      boxSizing: "border-box",
      padding: "0 14px",
    },
    "& .MuiOutlinedInput-root": {
      minHeight: 40,
      height: 40,
      paddingTop: 0,
      paddingBottom: 0,
    },
    "& .MuiAutocomplete-input": {
      paddingTop: "0 !important",
      paddingBottom: "0 !important",
    },
  },
  // Multi-select VM box: keep 40px but let the chip stay visible/centered
  vmField: {
    "& .MuiOutlinedInput-root": {
      height: 40,
      minHeight: 40,
      flexWrap: "nowrap",
      overflow: "hidden",
      paddingTop: "0 !important",
      paddingBottom: "0 !important",
    },
    "& .MuiChip-root": {
      height: 24,
    },
  },
  wrapper: {
    padding: 20,
    backgroundColor: "white",
    borderRadius: "10px",
  },
  noDataMessage: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  toggleWrapper: {
    display: "inline-flex",
    justifyContent: "start",
  },
  chartNoData: {
    background: "#ededed",
    height: "400px",
    borderRadius: "0.25rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "40px",
  },
}));
